import { SVGProps } from '@components/Icon/types';

export const Today = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2.5, 2)">
      <path
        d="M9.5 8.0752C10.1295 8.0753 10.6396 8.58537 10.6396 9.21484C10.6396 9.84439 10.1295 10.3554 9.5 10.3555C8.8704 10.3555 8.35938 9.84445 8.35938 9.21484C8.35946 8.58531 8.87045 8.0752 9.5 8.0752Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2002 0C17.2987 0.000105651 18.9999 1.70128 19 3.7998V15.2002C18.9999 17.2987 17.2987 18.9999 15.2002 19H10.0967V20.4941C10.0965 20.8031 9.84612 21.0534 9.53711 21.0537C9.2278 21.0537 8.97677 20.8032 8.97656 20.4941V19H3.7998C1.70128 18.9999 0.000105651 17.2987 0 15.2002V3.7998C0.000105399 1.70128 1.70128 0.000105522 3.7998 0H15.2002ZM1.33008 15.2002C1.33018 16.5642 2.43582 17.6698 3.7998 17.6699H8.97656V13.6689L6.73438 15.6855C6.50447 15.8921 6.15122 15.8734 5.94434 15.6436C5.73803 15.4137 5.75584 15.0603 5.98535 14.8535L9.16113 11.998L9.19141 11.9736C9.20417 11.9636 9.22028 11.9508 9.23828 11.9395C9.25392 11.9297 9.27157 11.9215 9.28027 11.917L9.32617 11.8945C9.39321 11.8676 9.4655 11.8545 9.53613 11.8545H9.54102C9.61042 11.8551 9.67983 11.8683 9.74512 11.8945C9.76378 11.902 9.78303 11.9124 9.79199 11.917C9.80415 11.9232 9.81807 11.9308 9.83203 11.9395C9.85489 11.9537 9.87505 11.9698 9.8916 11.9834L9.89062 11.9824L9.89355 11.9844C9.89646 11.9864 9.90316 11.9918 9.91016 11.998L13.0869 14.8535C13.3164 15.06 13.3361 15.4134 13.1299 15.6436C12.923 15.8737 12.5678 15.8922 12.3379 15.6855L10.0967 13.6709V17.6699H15.2002C16.5642 17.6698 17.6698 16.5642 17.6699 15.2002V5.7002H1.33008V15.2002ZM3.7998 1.33008C2.43582 1.33018 1.33018 2.43582 1.33008 3.7998V4.37012H17.6699V3.7998C17.6698 2.43582 16.5642 1.33018 15.2002 1.33008H3.7998Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'today';
